<template>
  <div>
    <div class="alignVHCenter" v-if="showLogo && logoUrl" v-bind:style="{ backgroundColor: logoBackgroundColor, paddingTop: '24px', paddingBottom: '24px' }">
      <img :src="logoUrl" :class="logoClass" />
    </div>

    <div class="alignVHCenter ui blue message" v-if="showDescription && description" :style="descriptionStyle" >
      {{ description }}
    </div>

    <div class="alignVHCenter" v-if="showSchoolName && schoolName" :style="schoolNameStyle">
        <h2>{{ schoolName }}</h2>
    </div>

  </div>
</template>

<script>
import { get } from 'lodash';
export default {
  name: "Branding",
  props: {
    logoUrl: {
      validator: prop => typeof prop === "string" || prop === null,
      required: false
    },
    logo: {
      type: Object,
      required: true
    },
    logoBackgroundColor: {
      validator: prop => typeof prop === "string" || prop === null,
      required: false,
      default: '#FFFFFF'
    },
    schoolName: {
      type: String,
      required: true
    },
    showSchoolName: {
      type: Boolean,
      default: true
    },
    showLogo: {
      type: Boolean,
      required: true,
      default: false
    },
    showDescription: {
      type: Boolean,
      required: true,
      default: false
    },
    description: {
      validator: prop => typeof prop === "string" || prop === null,
      required: false
    }
  },
  computed: {
    descriptionStyle () {
      return {
        borderRadius: 0,
        margin: 0
      }
    },
    schoolNameStyle() {
      const margin = '2rem';
      return {
        height: '30px',
        margin: `${margin} ${margin} 0 ${margin}`
      }
    },
    logoClass () {
      const baseClass = 'school-logo-img';
      const width = Number.parseInt(get(this.logo, 'info.width'));
      const height = Number.parseInt(get(this.logo, 'info.height'));
      const isSquare = width === height;
      const isLandscape = width > height;
      const isPortrait = height > width;
      if (isSquare) return `${baseClass} is-square`;
      if (isLandscape) return `${baseClass} is-landscape`;
      if (isPortrait) return `${baseClass} is-portrait`;
      return baseClass;
    }
  }
}
</script>

<style scoped>

.school-logo-img.is-square {
  max-height: 300px;
}

.school-logo-img.is-landscape {
  max-width: 500px;
}

.school-logo-img.is-portrait {
  max-height: 300px;
}

@media only screen and (max-width: 500px) {
  .school-logo-img.is-square {
    max-height: 220px;
  }
  .school-logo-img.is-landscape {
    max-width: 300px;
  }
  .school-logo-img.is-portrait{
    max-height: 200px;
  }
}

</style>
